// extracted by mini-css-extract-plugin
export default {"section":"OtherServices_section__XMB-P","container":"OtherServices_container__AGPPg","heading":"OtherServices_heading__mzxUI","contentWrapper":"OtherServices_contentWrapper__feO9p"};